export default __webpack_public_path__ + "static/media/trr-event-music-dj.68eb972d.png";